import type { MusicTask, GenMusic } from '~/services/musicService'

/** The parent supplies its already sorted, filtered and paginated display list. */
export function takePlaybackQueue(tasks: MusicTask[]): GenMusic[] {
  return tasks.flatMap(task => task.status > 3 ? [] : (task.music_data || [])
    .filter(song => !!song.audio_url && (task.status === 3 || !!song.metadata?.duration))
    .map(song => ({ ...song, audio_url: song.audio_oss || song.audio_url })))
}
